import React from "react";
import { useState, useEffect } from "react";
import useAxios from "../utils/useAxios";
import { hideModal, showModal } from "../utils/modalUtility";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { AppName } from "../config";
const APP_NAME = AppName.appName;

const UserConfirmation = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [otpLoader, setOtpLoader] = useState(false);
  const [otpSentLoader, setOtpSentLoader] = useState(false);
  const [status, setStatus] = useState(false);
  const [role, setRole] = useState(null);
  const { state } = useAppContext();

  const [step, setStep] = useState(1);
  const axiosAPI = useAxios(); // Use the custom hook for Axios
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    user_id: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    phone_number: "",
    email: "",
    favicon_url: "",
    btg_magazine_status: "",
    connectivity_status: "",
    want_80g: "",
    pan_no: "",
    date_of_birth: "",
    patronship_level: "",
    whatsapp_number: "",
    full_name: "",
    email: "",
  });

  // function handleChange(e) {
  //   setFormData({ ...formData, [e.target.id]: e.target.value });
  // }

  function handleChange(e) {
    const { id, value } = e.target;

    // If the field is pan_no, convert the value to uppercase
    setFormData({
      ...formData,
      [id]: id === "pan_no" ? value.toUpperCase() : value,
    });
  }

  // const validateStep = () => {
  //   switch (step) {
  //     case 1:
  //       return (formData.address ?? "").trim() !== "";
  //     case 2:
  //       return (formData.zip_code ?? "").trim() !== "";
  //     case 3:
  //       if (formData.want_80g === "") return false;
  //       if (formData.want_80g === "Y") {
  //         return (formData.pan_no ?? "").trim() !== "";
  //       }
  //       return true;
  //     case 4:
  //       return formData.date_of_birth !== "";
  //     case 5:
  //       return (formData.whatsapp_number ?? "").trim() !== "";
  //     case 6:
  //       return (formData.full_name ?? "").trim() !== "";
  //     case 7:
  //       return (formData.email ?? "").trim() !== "";
  //     case 8:
  //       return true;
  //     default:
  //       return false;
  //   }
  // };

  const validateStep = () => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN card format regex

    switch (step) {
      case 1:
        return (formData.full_name ?? "").trim() !== "";
      case 2:
        return true; //  No validation for email
      case 3:
        return (formData.address ?? "").trim() !== "";
      case 4:
        return (formData.zip_code ?? "").trim() !== "";
      case 5:
        if (formData.want_80g === "") return false;
        if (formData.want_80g === "Y") {
          const pan = (formData.pan_no ?? "").trim().toUpperCase(); // Convert PAN to uppercase
          return panRegex.test(pan); // Validate PAN using regex
        }
        return true;
      case 6:
        return formData.date_of_birth !== "";
      case 7:
        return (formData.whatsapp_number ?? "").trim() !== "";
      case 8:
        return true;
      default:
        return false;
    }
  };

  const handleNext = async (e) => {
    e.preventDefault();

    if (!validateStep()) {
      // PAN validation error for step 5
      if (step === 5 && formData.want_80g === "Y") {
        alert("Please enter a valid PAN number (e.g., ABCDE1234F)");
        return;
      }
      alert("Please fill the required field.");
      return;
    }
    if (step < 8) {
      setStep(step + 1);
    } else {
      // Submit

      const payload = {
        pan_no: formData.pan_no || "",
        address: formData.address,
        zip_code: formData.zip_code,
        want_80g: formData.want_80g === "Y" ? "Y" : "N",
        date_of_birth: formData.date_of_birth || "",
        whatsapp_number: formData.whatsapp_number,
        full_name: formData.full_name,
        email: formData.email,
      };

      // console.log("Sending user details:", payload);

      // return

      try {
        const response = await axiosAPI.post(
          "/api/users/verify-user-details",
          payload,
        );

        if (response.status === 200) {
          window.notifyMessage(
            "Success",
            response.data.message || "Details submitted successfully",
            "success",
          );

          navigate("/user/account-settings");
        } else {
          console.error("Failed to submit details:", response.data.message);
          alert("Failed to submit details");
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          "There was an error submitting your details.";

        window.notifyMessage("Error", errorMessage, "danger");
        console.error("Submission error:", errorMessage);
      }

      alert("Form submitted successfully!");

      hideModal("confirmationModal");
      showModal("staticBackdrop");
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  async function handleOtpSubmit(e) {
    e.preventDefault();

    if (otp.length !== 6 || isNaN(otp)) {
      alert("Please enter a valid 6-digit OTP.");
      return;
    }

    if (newPassword.length < 6) {
      alert("Password must be at least 6 characters.");
      return;
    }

    // console.log("OTP:", otp);
    // console.log("New Password:", newPassword);

    const payload = {
      password: newPassword,
      otp: otp,
    };

    setOtpLoader(true);

    try {
      let response = await axiosAPI.post(`/api/whatsapp/verify-otp`, payload);
      // hideModal("staticBackdrop");
      // console.log("Response", response);
      if (response.status === 200) {
        window.notifyMessage(
          "Success",
          "Password Changed successfully",
          "success",
        );
        setStatus(true);
        // Redirect after success
        // window.location.href = "/logout";
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger",
        );
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }

    // Reset and close
    setOtpLoader(false);
    setOtp("");
  }

  async function otpHandler() {
    setOtpSentLoader(true);

    try {
      // 1. API Call to send OTP
      const response = await axiosAPI.get("/api/whatsapp/send-otp");

      if (response.status === 200) {
        // 2. Show success notification with backend message
        window.notifyMessage(
          "Success",
          response.data.message ||
            "OTP sent successfully on whatsapp and email",
          "success",
        );
        // console.log("OTP sent successfully");
      } else {
        console.error("Failed to send OTP:", response.data.message);
        alert("Failed to send OTP");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "There was an error sending OTP!";

      window.notifyMessage("Error", errorMessage, "danger");

      console.error("OTP send error:", errorMessage);
    }
    setOtpSentLoader(false);
  }

  const fetchUserData = async () => {
    try {
      const response = await axiosAPI.get(`/api/users/get-user-details`);
      const userData = response.data;
      setUsers(userData);
      // console.log("User Data ", userData);au
      setCurrentUserId(userData?.user_id);
      setFormData(userData);
      setLoading(false);
    } catch (error) {
      // console.error("Error fetching ads:", error);
      setLoading(false);
    }
  };

  function handleLogout() {
    navigate("/logout");
    window.location.reload();
  }

  useEffect(() => {
    async function handleCheck() {
      if (role === "donor") {
        try {
          const response = await axiosAPI.get(`/api/users/get-user-status`);
          const { status } = response.data;
          // setPasswordStatus(passwordStatus);
          // console.log("User Status:", status);

          if (status == "yes") {
            // setTimeout(() => {
            // showModal("confirmationModal");
            // }, 1000);
            navigate("/user/account-settings");
          }
        } catch (error) {
          console.error("Error fetching status:", error);
        }
      }
    }

    handleCheck(); // run async logic
  }, [role]);

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role"));
    setRole(state?.user?.role);
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-center align-items-center vh-100">
        {status ? (
          <FirstCard
            step={step}
            formData={formData}
            handleChange={handleChange}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        ) : (
          <SecondCard
            formData={formData}
            handleOtpSubmit={handleOtpSubmit}
            otpHandler={otpHandler}
            otp={otp}
            setOtp={setOtp}
            handleChange={handleChange}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            otpLoader={otpLoader}
            otpSentLoader={otpSentLoader}
          />
        )}
      </div>
      <button
        onClick={handleLogout}
        className="btn btn-danger position-absolute bottom-0 end-0 mb-5 me-5"
      >
        Logout
      </button>
    </div>
  );
};

const FirstCard = ({
  step,
  formData,
  handleChange,
  handleNext,
  handleBack,
}) => {
  return (
    <div className="card log-card p-4">
      <div className="mb-4">
        <div className="text-center">
          <img
            src="/icon/main-logo.webp"
            alt="Logo"
            className="img-fluid mb-3 rounded-circle"
            width="140"
          />
        </div>
        <h5 className="card-title log-title text-center">
          Welcome Back to {APP_NAME}
        </h5>
      </div>
      <div className="container py-4">
        <h2 className="mb-3">Step {step} of 8</h2>
        <form onSubmit={handleNext}>
          {/* Add your step-wise form logic here as already written */}
          {step === 1 && (
            <div className="mb-3">
              <label htmlFor="full_name" className="form-label">
                Full Name *
              </label>
              <input
                type="text"
                id="full_name"
                required
                className="form-control"
                value={formData.full_name}
                onChange={handleChange}
              />
            </div>
          )}

          {/* Add your step-wise form logic here as already written */}
          {step === 2 && (
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email *
              </label>
              <input
                type="text"
                id="email"
                placeholder="Enter your email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          )}

          {/* Add your step-wise form logic here as already written */}
          {step === 3 && (
            <div className="mb-3">
              <label htmlFor="address" className="form-label">
                Address *
              </label>
              <input
                type="text"
                id="address"
                placeholder="for prasadam and magazine"
                className="form-control"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
          )}

          {step === 4 && (
            <div className="mb-3">
              <label htmlFor="zip_code" className="form-label">
                Zip Code *
              </label>
              <input
                type="text"
                id="zip_code"
                maxLength={6}
                className="form-control"
                value={formData.zip_code}
                onChange={handleChange}
                required
              />
            </div>
          )}

          {step === 5 && (
            <>
              <div className="mb-3">
                <label htmlFor="want_80g" className="form-label">
                  Do you want 80G?
                </label>
                <select
                  id="want_80g"
                  className="form-select"
                  value={formData.want_80g}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Select Option
                  </option>
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </div>

              {formData.want_80g === "Y" && (
                <div className="mb-3">
                  <label htmlFor="pan_no" className="form-label">
                    PAN Card Number *
                  </label>
                  <input
                    type="text"
                    id="pan_no"
                    name="pan_no"
                    className="form-control"
                    value={formData.pan_no}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </>
          )}

          {step === 6 && (
            <div className="mb-3">
              <label htmlFor="date_of_birth" className="form-label">
                Date of Birth *
              </label>
              <input
                type="date"
                id="date_of_birth"
                required
                className="form-control"
                placeholder=" to receive prasadam and prayers"
                value={formData.date_of_birth}
                onChange={handleChange}
              />
            </div>
          )}

          {step === 7 && (
            <div className="mb-3">
              <label htmlFor="whatsapp_number" className="form-label">
                WhatsApp Number *
              </label>
              <input
                type="text"
                id="whatsapp_number"
                className="form-control"
                value={formData.whatsapp_number}
                onChange={handleChange}
                required
              />
            </div>
          )}

          {step === 8 && (
            <div>
              <h5>Please confirm your details:</h5>
              <ul className="list-group">
                <li className="list-group-item">
                  <strong>Full Name:</strong> {formData.full_name}
                </li>
                <li className="list-group-item">
                  <strong>Email:</strong> {formData.email}
                </li>
                <li className="list-group-item">
                  <strong>Address:</strong> {formData.address}
                </li>
                <li className="list-group-item">
                  <strong>Zip Code:</strong> {formData.zip_code}
                </li>
                <li className="list-group-item">
                  <strong>Want 80G:</strong> {formData.want_80g}
                </li>
                {formData.want_80g === "Y" && (
                  <li className="list-group-item">
                    <strong>PAN Card Number:</strong> {formData.pan_no}
                  </li>
                )}
                <li className="list-group-item">
                  <strong>Date of Birth:</strong> {formData.date_of_birth}
                </li>
                <li className="list-group-item">
                  <strong>WhatsApp Number:</strong> {formData.whatsapp_number}
                </li>
              </ul>
            </div>
          )}

          <div className="d-flex justify-content-between mt-4">
            {step > 1 && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleBack}
              >
                Back
              </button>
            )}
            <button type="submit" className="btn btn-primary">
              {step === 8 ? "Submit" : "Next"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const SecondCard = ({
  formData,
  handleOtpSubmit,
  otpHandler,
  otp,
  setOtp,
  newPassword,
  setNewPassword,
  otpLoader,
  otpSentLoader,
}) => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div
        className="card shadow p-4"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="card-header text-center bg-white border-0">
            <h5 className="mb-0">Please Change Your Password</h5>
          </div>

          <div className="card-body">
            {/* Pre-filled WhatsApp Number */}
            <div className="mb-3">
              <label className="form-label">WhatsApp Number</label>
              <input
                type="text"
                className="form-control"
                value={formData.whatsapp_number ?? ""}
                readOnly
              />
            </div>

            {/* Pre-filled Email */}
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                value={formData.email ?? ""}
                readOnly
              />
            </div>

            <div class="alert mt-3">
              <strong>Note:</strong> If WhatsApp or Email is not correctly.
              Please connect ISKCON KANPUR FOLK OFFICE
            </div>

            <p className="text-center mb-3">
              Please enter the 6-digit OTP sent to your WhatsApp or Email.
            </p>

            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                maxLength={6}
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <button
              type="button"
              className="btn btn-success"
              onClick={otpHandler}
              disabled={otpLoader}
            >
              {otpSentLoader ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Sending...
                </>
              ) : (
                "Send OTP"
              )}
            </button>
          </div>

          <div className="card-footer">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={handleOtpSubmit}
              disabled={otpLoader}
            >
              {otpLoader ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving...
                </>
              ) : (
                "Verify and save password"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserConfirmation;
